import { getMerchantToken } from "./merchantAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_MERCHANT_API_BASE_URL ||
  "http://secondbite-manage.localhost/merchant-api/v1"
).replace(/\/+$/, "");

export const getMerchantDashboard = async (outletId = "") => {
  const query = new URLSearchParams();
  if (outletId) query.set("outlet_id", outletId);

  let response;
  try {
    response = await fetch(`${API_BASE_URL}/dashboard?${query}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getMerchantToken()}`,
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }

  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) {
    throw new Error(payload?.message || "Unable to load the merchant dashboard.");
  }
  return payload.data;
};
